"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentItemSystemAttributes = /** @class */ (function () {
    function ContentItemSystemAttributes(data) {
        Object.assign(this, data);
    }
    return ContentItemSystemAttributes;
}());
exports.ContentItemSystemAttributes = ContentItemSystemAttributes;
//# sourceMappingURL=content-item-system-attributes.js.map